import { DialogActions, CircularProgress } from '@mui/material'
import ShareIcon from '@mui/icons-material/Share'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Button as CustomButton } from '@ds/components'
import { useCopyToClipboard } from '../hooks'

interface ModalActionsProps {
  hasSharedUrl: boolean
  isLoading: boolean
  selectedCount: number
  shareText: string
  onClose: () => void
  onDeselectAll: () => void
  onShare: () => void
}

export const ModalActions = ({
  hasSharedUrl,
  isLoading,
  selectedCount,
  shareText,
  onClose,
  onDeselectAll,
  onShare,
}: ModalActionsProps) => {
  const { copyToClipboard } = useCopyToClipboard()

  return (
    <DialogActions sx={{ px: 4, pb: 4 }}>
      {hasSharedUrl ? (
        <>
          <CustomButton onClick={() => copyToClipboard(shareText)} startIcon={<ContentCopyIcon />}>
            Copy
          </CustomButton>
          <CustomButton onClick={onClose} variant="contained" color="primary">
            Close
          </CustomButton>
        </>
      ) : (
        <>
          <CustomButton onClick={onDeselectAll} color="inherit">
            Deselect all
          </CustomButton>
          <CustomButton
            variant="contained"
            color="primary"
            onClick={onShare}
            disabled={isLoading || selectedCount === 0}
            startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <ShareIcon />}
          >
            {isLoading ? 'Sharing...' : 'Share songs'}
          </CustomButton>
        </>
      )}
    </DialogActions>
  )
}
